
let BASE_URL = ''
const TIME_OUT = 50000
console.log(process.env.NODE_ENV)
if (process.env.NODE_ENV === 'development') {
    BASE_URL = 'https://ry.app.1qit.com'
} else if (process.env.NODE_ENV === 'production') {
    BASE_URL = 'https://ry.app.1qit.com'
} else {
    BASE_URL = ''
}

export { BASE_URL, TIME_OUT }
